export enum DocumentListingPageType {
  Staff,
  Students
}

export enum DocumentListingFullPageType {
  Category,
  Saved
}